<script setup lang="ts">
import type { CartItem } from "@features/shopping/types";

import { useCart } from "@features/shopping/composables";
import { toast } from "@ui/toast";
import { X } from "lucide-vue-next";

const props = defineProps<{
  class?: string;
  iconClass?: string;
  item: CartItem;
}>();

const { error, removeFromCart } = useCart();

const onSubmit = async () => {
  try {
    await removeFromCart(props.item.product_sku_id.toString());

    if (error.value) {
      toast({
        description: error.value,
        title: "Cart Error",
        variant: "destructive",
      });
      return;
    }
  } catch (error) {
    toast({
      description:
        "We couldn't connect to our servers. Please check your internet connection and try again.",
      title: "Connection Error",
      variant: "destructive",
    });
    console.error("[Remove From Cart]:", error);
  }
};
</script>

<template>
  <button
    :class="[
      'group flex size-6 min-w-6 items-center justify-center rounded-full border border-muted-foreground/50 hover:border-foreground',
      props.class,
    ]"
    @click.prevent="onSubmit"
  >
    <X :class="['size-4 text-muted-foreground/50 group-hover:text-foreground', props.iconClass]" />
  </button>
</template>
